import React, { useState } from 'react';
import { ContractForm } from '../components/ContractForm';
import { ContractList } from '../components/ContractList';
import { FileText, Plus } from 'lucide-react';

export function ContractsPage() {
  const [showCreateForm, setShowCreateForm] = useState(false);

  return (
    <div className="max-w-4xl mx-auto py-8">
      {showCreateForm ? (
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="w-8 h-8 text-primary-400" />
            <h1 className="text-2xl font-bold">Create New Contract</h1>
          </div>
          <ContractForm
            onSuccess={() => setShowCreateForm(false)}
            onCancel={() => setShowCreateForm(false)}
          />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold">Contracts</h1>
            <button
              onClick={() => setShowCreateForm(true)}
              className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 flex items-center gap-2"
            >
              <Plus className="w-5 h-5" />
              Create Contract
            </button>
          </div>
          <ContractList />
        </div>
      )}
    </div>
  );
}